import { render, staticRenderFns } from "./SubjectTeachers.vue?vue&type=template&id=4eebe81f&scoped=true"
import script from "./SubjectTeachers.vue?vue&type=script&lang=js"
export * from "./SubjectTeachers.vue?vue&type=script&lang=js"
import style0 from "./SubjectTeachers.vue?vue&type=style&index=0&id=4eebe81f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eebe81f",
  null
  
)

export default component.exports